// extracted by mini-css-extract-plugin
export default {"container":"ModeLoadingContent_container__Bx4At","spinner":"ModeLoadingContent_spinner__Nlhys","spin":"ModeLoadingContent_spin__k1Kx4","message":"ModeLoadingContent_message__5UrMu"};